
      <b4a-product-simple-travel-form
          [travel]="travel"
          [boardTypes]="boardTypes"
          [regions]="regions"
          [productTypes$]="productTypes$"
      ></b4a-product-simple-travel-form>
    


// WEBPACK FOOTER //
// ./src/app/product/simple-travel-detail-page.container.ts.SimpleTravelDetailPageComponent.html